import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import React from 'react';
import { styled, Box, color, Text } from '@landr/maestro';
import { useProfileCompletionQuery } from './hooks/useProfileCompletionQuery.es.js';

var _templateObject, _templateObject2;
var ProgressBox = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 4px;\n    border-radius: 8px;\n    width: 56px;\n    background-color: ", ";\n    overflow: hidden;\n"])), color('neutral.600'));
var ProgressLine = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 100%;\n    border-radius: 8px;\n    width: ", ";\n    background-color: ", ";\n"])), function (_ref) {
  var progress = _ref.progress;
  return "".concat(progress, "%");
}, color('secondary.500'));
var ProfileCompletion = function ProfileCompletion() {
  var _useProfileCompletion = useProfileCompletionQuery(),
    profileCompletionProgress = _useProfileCompletion.profileCompletionProgress,
    isLoading = _useProfileCompletion.isLoading,
    error = _useProfileCompletion.error;
  if (isLoading || error || profileCompletionProgress === undefined || profileCompletionProgress >= 100 || profileCompletionProgress < 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "data-testid": "profile-completion-progress"
  }, /*#__PURE__*/React.createElement(ProgressBox, null, /*#__PURE__*/React.createElement(ProgressLine, {
    progress: profileCompletionProgress
  })), /*#__PURE__*/React.createElement(Text, {
    ml: "xs",
    size: "xs"
  }, profileCompletionProgress, "%"));
};

export { ProfileCompletion, ProgressBox, ProgressLine };
